// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");

function id(t) {
  return t.id;
}

function dataField(t) {
  return t.dataField;
}

function mandatory(t) {
  return t.mandatory;
}

function showInReport(t) {
  return t.showInReport;
}

function setDataField(t, x) {
  return {
          id: t.id,
          dataField: x,
          mandatory: t.mandatory,
          showInReport: t.showInReport
        };
}

function setMandatory(t, x) {
  return {
          id: t.id,
          dataField: t.dataField,
          mandatory: x,
          showInReport: t.showInReport
        };
}

function setShowInReport(t, x) {
  return {
          id: t.id,
          dataField: t.dataField,
          mandatory: t.mandatory,
          showInReport: x
        };
}

function empty(param) {
  return {
          id: undefined,
          dataField: DataField$ReactHooksTemplate.empty(),
          mandatory: false,
          showInReport: true
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          dataField: Json_decode.field("data_field", DataField$ReactHooksTemplate.decode, json),
          mandatory: Json_decode.field("mandatory", Json_decode.bool, json),
          showInReport: Json_decode.withDefault(true, (function (param) {
                  return Json_decode.field("show_in_report", Json_decode.bool, param);
                }), json)
        };
}

function encode(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "mandatory",
                  t.mandatory
                ],
                tl: {
                  hd: [
                    "show_in_report",
                    t.showInReport
                  ],
                  tl: {
                    hd: [
                      "data_field_id",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), DataField$ReactHooksTemplate.id(t.dataField))
                    ],
                    tl: {
                      hd: [
                        "_destroy",
                        destroy
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

exports.id = id;
exports.dataField = dataField;
exports.mandatory = mandatory;
exports.showInReport = showInReport;
exports.setDataField = setDataField;
exports.setMandatory = setMandatory;
exports.setShowInReport = setShowInReport;
exports.empty = empty;
exports.decode = decode;
exports.encode = encode;
/* DataField-ReactHooksTemplate Not a pure module */
